var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'whatwg-fetch';
import modal from './modal';
// It has been decided to host this key client side for now.
// This will be implemented in BE later.
var HEINEKEN_RAAS_KEY = '66e874c31dc9456da19dbe62f676db63';
var RAAS_API_URL = 'https://logicapi.heineken.nl/raas/api/Folder';
function getReferrals(id) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(RAAS_API_URL, "/").concat(id), {
                        headers: {
                            'Ocp-Apim-Subscription-Key': HEINEKEN_RAAS_KEY,
                        },
                    })
                        .then(function (response) {
                        var status = response.status, statusText = response.statusText;
                        if (status === 200) {
                            return response.json();
                        }
                        return statusText;
                    })
                        .catch(function (ex) {
                        return JSON.stringify(ex);
                    })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
function createReferral(deeplink) {
    if (!deeplink)
        return null;
    var name = deeplink.name, image = deeplink.image, url = deeplink.url;
    return "\n        <li class=\"raas__list-item\">\n            <a href=\"".concat(url, "\" class=\"raas__referral-link\">\n                <img src=\"").concat(image, "\" class=\"raas__referral-image\" alt=\"").concat(name, "\" />\n                <span class=\"raas__referral-title\">").concat(name, "</span>\n            </a>\n        </li>\n    ");
}
function createReferralsTemplate(data) {
    var name = data.name, deeplinks = data.deeplinks;
    return "\n        <h1 class=\"raas__title\">".concat(name, "</h1>\n        <ul class=\"raas__list\">\n            ").concat(deeplinks
        .map(function (deeplink) { return createReferral(deeplink); })
        .join(''), "\n        </ul>\n    ");
}
function createErrorTemplate(data, productId) {
    return "\n        <h1>".concat(data, "</h1>\n        <p>Product: ").concat(productId, "</p>\n    ");
}
function eachButton(button) {
    var _this = this;
    var id = button.getAttribute('data-raas-sku-id');
    if (!id)
        return;
    var clickHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        var data, modalContent;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getReferrals(id)];
                case 1:
                    data = _a.sent();
                    modalContent = '';
                    if (data && data.name) {
                        modalContent = createReferralsTemplate(data);
                    }
                    else {
                        modalContent = createErrorTemplate(data, id);
                    }
                    modal.open(modalContent);
                    return [2 /*return*/];
            }
        });
    }); };
    button.addEventListener('click', clickHandler);
}
var raasButton = function () {
    var buttons = document.querySelectorAll('[data-raas-sku-id]');
    buttons.forEach(function (button) { return eachButton(button); });
};
export default raasButton;
